import { MODALS } from '~/shared/constants/modals';
import { closeResponsiveModal, openResponsiveModal } from '~/shared/ui/ResponsiveModals';
import { type DeclineOrderProps } from '../DeclineOrder';

export const openDeclineOrderModal = (props: DeclineOrderProps) => {
    openResponsiveModal({
        modalId: MODALS.PAYOUT_ORDER_REJECTION,
        modal: MODALS.PAYOUT_ORDER_REJECTION,
        title: 'Отклонение ордера',
        innerProps: {
            ...props,
            onSuccess: () => {
                closeResponsiveModal(MODALS.PAYOUT_ORDER_REJECTION);
                props.onSuccess?.();
            },
            onCancel: () => {
                closeResponsiveModal(MODALS.PAYOUT_ORDER_REJECTION);
            },
        },
    });
};
